export function commentHasAnnotation(annotation): boolean {
  if (!annotation || !annotation.shape) {
    return false;
  }
  try {
    const shapeData = typeof annotation.shape === 'string' ? JSON.parse(annotation.shape) : annotation.shape;
    return !!(shapeData?.objects && Array.isArray(shapeData.objects) && shapeData.objects.length > 0);
  } catch {
    return false;
  }
}
